import { defineStore } from "pinia";

export const useAppStore = defineStore("app", {
  state: () => ({
    deviceType: "",
    envMode: "",
    axiosHeaders: {},
    isLogin: false,
    sideBarShow: true,
    userInfo: {},
    videoWide: false,
    preRoute: "",
    alertStr: "",
    order: {},
    createOrderShow: false,
    createFresh: false,
    registerWindowShow: false,
    forgetPasswordWindowShow: false,
  }),
  actions: {
    setDeviceType(payload) {
      this.deviceType = payload;
    },
    setEnvMode(payload) {
      this.envMode =
        payload !== "devel" && payload !== "prod" ? "devel" : payload;
    },
    setAxiosHeaders(payload) {
      if (payload.val) {
        this.axiosHeaders[payload.key] = payload.val;
      } else {
        delete this.axiosHeaders[payload.key];
      }
    },
    setIsLogin(payload) {
      this.isLogin = payload;
    },
    setSideBarShow(payload) {
      this.sideBarShow = payload;
    },
    setUserInfo(payload) {
      this.userInfo = payload;
    },
    setVideoWide(payload) {
      this.videoWide = payload;
    },
    setRegisterWindowShow(payload) {
      this.registerWindowShow = payload;
    },
    setForgetPasswordWindowShow(payload) {
      this.forgetPasswordWindowShow = payload;
    },
    setPreRoute(payload) {
      this.preRoute = payload;
    },
    setAlertStr(payload) {
      this.alertStr = payload;
    },
    setOrder(payload) {
      this.order = payload;
    },
    setCreateOrderShow(payload) {
      this.createOrderShow = payload;
    },
    setCreateFresh(payload) {
      this.createFresh = payload;
    },
  },
});
